import { render } from "./EmpleadosForm-Component.vue?vue&type=template&id=4c800a07&scoped=true"
import script from "./EmpleadosForm-Component.vue?vue&type=script&lang=js"
export * from "./EmpleadosForm-Component.vue?vue&type=script&lang=js"

import "./EmpleadosForm-Component.vue?vue&type=style&index=0&id=4c800a07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c800a07"]])

export default __exports__